/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Origin_Download_TextInputs */

const en_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Brave Origin`)
};

const id_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unduh Brave Origin`)
};

const ms_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muat turun Brave Origin`)
};

const ca_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarrega Brave Origin`)
};

const cs_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stáhnout Brave Origin`)
};

const da_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Brave Origin`)
};

const de_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin herunterladen`)
};

const et_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laadi Brave Origin alla`)
};

const es_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar Brave Origin`)
};

const fr_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger Brave Origin`)
};

const hr_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preuzmite Brave Origin`)
};

const it_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica Brave Origin`)
};

const lv_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lejupielādēt Brave Origin`)
};

const lt_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atsisiųsti Brave Origin`)
};

const hu_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin letöltése`)
};

const nl_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin downloaden`)
};

const nb_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last ned Brave Origin`)
};

const pl_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobierz Brave Origin`)
};

const pt_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixar Brave Origin`)
};

const ro_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarcă Brave Origin`)
};

const sk_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stiahnuť Brave Origin`)
};

const sl_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenesite Brave Origin`)
};

const fi_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa Brave Origin`)
};

const sv_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda ner Brave Origin`)
};

const vi_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải xuống Brave Origin`)
};

const tr_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin'i İndir`)
};

const el_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Λήψη Brave Origin`)
};

const bg_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изтеглете Brave Origin`)
};

const ru_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скачать Brave Origin`)
};

const sr_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преузмите Brave Origin`)
};

const uk_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантажити Brave Origin`)
};

const ka_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ჩამოტვირთეთ Brave Origin`)
};

const hi_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin डाउनलोड करें`)
};

const th_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดาวน์โหลด Brave Origin`)
};

const ko_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin 다운로드`)
};

const zh_tw_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下載 Brave Origin`)
};

const ja_origin_download_text = /** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin をダウンロード`)
};

/** @type {(inputs: Origin_Download_TextInputs) => LocalizedString} */
const zh_origin_download_text = en_origin_download_text;

/**
* | output |
* | --- |
* | "Download Brave Origin" |
*
* @param {Origin_Download_TextInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const origin_download_text = /** @type {((inputs?: Origin_Download_TextInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Origin_Download_TextInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_origin_download_text(inputs)
	if (locale === "ms") return ms_origin_download_text(inputs)
	if (locale === "ca") return ca_origin_download_text(inputs)
	if (locale === "cs") return cs_origin_download_text(inputs)
	if (locale === "da") return da_origin_download_text(inputs)
	if (locale === "de") return de_origin_download_text(inputs)
	if (locale === "et") return et_origin_download_text(inputs)
	if (locale === "es") return es_origin_download_text(inputs)
	if (locale === "fr") return fr_origin_download_text(inputs)
	if (locale === "hr") return hr_origin_download_text(inputs)
	if (locale === "it") return it_origin_download_text(inputs)
	if (locale === "lv") return lv_origin_download_text(inputs)
	if (locale === "lt") return lt_origin_download_text(inputs)
	if (locale === "hu") return hu_origin_download_text(inputs)
	if (locale === "nl") return nl_origin_download_text(inputs)
	if (locale === "nb") return nb_origin_download_text(inputs)
	if (locale === "pl") return pl_origin_download_text(inputs)
	if (locale === "pt") return pt_origin_download_text(inputs)
	if (locale === "ro") return ro_origin_download_text(inputs)
	if (locale === "sk") return sk_origin_download_text(inputs)
	if (locale === "sl") return sl_origin_download_text(inputs)
	if (locale === "fi") return fi_origin_download_text(inputs)
	if (locale === "sv") return sv_origin_download_text(inputs)
	if (locale === "vi") return vi_origin_download_text(inputs)
	if (locale === "tr") return tr_origin_download_text(inputs)
	if (locale === "el") return el_origin_download_text(inputs)
	if (locale === "bg") return bg_origin_download_text(inputs)
	if (locale === "ru") return ru_origin_download_text(inputs)
	if (locale === "sr") return sr_origin_download_text(inputs)
	if (locale === "uk") return uk_origin_download_text(inputs)
	if (locale === "ka") return ka_origin_download_text(inputs)
	if (locale === "hi") return hi_origin_download_text(inputs)
	if (locale === "th") return th_origin_download_text(inputs)
	if (locale === "ko") return ko_origin_download_text(inputs)
	if (locale === "zh") return zh_origin_download_text(inputs)
	if (locale === "zh-tw") return zh_tw_origin_download_text(inputs)
	if (locale === "ja") return ja_origin_download_text(inputs)
	return en_origin_download_text(inputs)
});